import { render, staticRenderFns } from "./supportPage.vue?vue&type=template&id=4bd91438&scoped=true&"
import script from "./supportPage.vue?vue&type=script&lang=js&"
export * from "./supportPage.vue?vue&type=script&lang=js&"
import style0 from "./supportPage.vue?vue&type=style&index=0&id=4bd91438&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd91438",
  null
  
)

export default component.exports